import {CgWebsite} from "react-icons/cg";

import {PiUserSquareFill} from "react-icons/pi";
import {useState} from "react";
import BottomButtonWrapper from "../BottomButtonWrapper";
import Button from "../Button";

const Addon = ({addonPrice,defaultSelectedAddonType,mainPrice, onSelect}) => {



    const handleSubmit = () => {

        onSelect(selected === "Addon")
    }
    const defaults = [

     /*   {
            icon: <CgWebsite className="text-gray-500 text-5xl "/>,
            title: 'افزودن روی این آگهی',
            description: 'با انتخاب این گزینه، افزونه تنها بر روی این آگهی قرار خواهد گرفت.',
            defaultType: 'post',

        },*/
        {
            icon: <PiUserSquareFill className="text-gray-500 text-5xl "/>,
            title: 'افزودن روی حساب کاربری',
            description: <span className="text-gray-700 text-sm">افزونه بر روی <strong>تمامی آگهی‌های</strong> شما به مدت سه ماه اضافه
                خواهد شد و هر آگهی جدیدی که ثبت کنید این افزونه بر روی آن نیز قرار خواهد گرفت.</span>,
            defaultType: 'Addon',

        }
    ];
    const [selected, setSelected] = useState(defaultSelectedAddonType==="1" ? defaults[1].defaultType:defaults[0].defaultType);

    const handleSelect = (type) => {

        setSelected(type);
    }
    return <div className="w-11/12 mx-auto mt-10  lg:w-6/12 ">
        <div className="flex justify-center flex-col items-center ">
            <h1 className=" text-2xl mb-2  text-gray-700">استعلام وضعیت معاملاتی</h1>
     {/*       <p className="text-sm mb-6 ">برای ادامه یکی از گزینه‌های زیر را انتخاب کنید</p>*/}
        </div>
        {defaults.map(item => {
            return <AccessCard key={item.defaultType} price={item.defaultType === "Addon" ? addonPrice : mainPrice} data={item}
                               selectedType={selected}
                               onSelect={handleSelect}/>
        })}
        <BottomButtonWrapper>
            <Button theme="green" onClick={handleSubmit} rounded="rounded-lg" className="text-sm ">شروع</Button>
        </BottomButtonWrapper>
    </div>
}
const AccessCard = ({data, price, onSelect, selectedType}) => {
    const {defaultType, title, description, icon} = data;
    const formattedPrice = new Intl.NumberFormat('fa-IR');

    return <div onClick={() => {
        onSelect(defaultType)
    }}
                className={`p-5 bg-white flex justify-start items-start flex-col rounded-xl mb-3 ${defaultType === selectedType ? 'border-2 border-green-500 shadow-xl  opacity-100' : 'opacity-90 border-2 border-white'}`}>
        <div className="justify-start flex gap-5 w-full  items-start">
            <div className="p-3 w-20 h-full flex justify-center items-center rounded-lg bg-gray-100 ">{icon}</div>
            <div className="w-full flex flex-col">
                <h1 className="font-bold   mb-2  ">{title}</h1>
                <p className="text-sm mb-2 text-gray-700">{description}</p>
                <div className="flex justify-end  w-full   ">
                    <span
                        className=" py-1 px-3 font-bold   text-green-500  w-auto rounded-full ">{formattedPrice.format(price / 10)}
                        <small className="mx-1 text-sm  ">تومان</small></span>
                </div>
            </div>
        </div>

    </div>
}
export default Addon;